import {Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {RxComponent} from '../../../core/components/common/rx.component';

declare var $: any;

@Component({
  selector: 'itpx-filter-section',
  templateUrl: './filter-section.component.html',
  styleUrls: ['./filter-section.component.css']
})
export class FilterSectionComponent extends RxComponent implements OnInit {

    @ViewChild('collapseFilterList') collapseFilterList : ElementRef;
    @Input() private filters: any;
    @Input() private scrollable: any = true;
    @Output() filterChanged = new EventEmitter<any>();
    private filterFields: any;
    private options: Array<any>;
    private resetCombobox: boolean;
    private clearOptions: boolean;
    private comboboxValue: any;
    selectAllForm: FormGroup;

    constructor(
        private fb: FormBuilder
    ) {
        super();
    }

    ngOnInit() {
        this.selectAllForm =  this.fb.group({
            selectAll: [true]
        });
        this.options = this.filters.options;
        this.getFilterFields();

        this.selectAllForm.controls.selectAll.valueChanges
            .distinctUntilChanged()
            .bindToLifecycle(this)
            .subscribe(
                change => {
                    if (change)  {
                        this.emitChangeOnCombobox(null);
                        this.clearComboboxoptions();
                    }
                }
            )
    }

    ngOnChanges(change: SimpleChanges) {
        if (change['filters']) {
           this.clearComboboxoptions();
           if (this.selectAllForm) this.selectAllForm.controls.selectAll.setValue(true);
        }
    }

    private clearComboboxoptions() {
        this.getFilterFields();
        this.clearOptions = true;
        this.resetCombobox = true;
        this.options = this.filters.options;
        setTimeout(_ => this.resetCombobox = false, 1);
        setTimeout(_ => this.clearOptions = false, 1);
    }

    private getFilterFields() {
        this.filterFields = {
            key: this.filters.key,
            minOnly: 0,
            cutOffUpper : 5,
            cutOffLower: 5,
            options: this.filters.options,
            formatter: (item) => {
                return item
            },
            level: 1
        };
    }

    private onTypeSelect(e: any) {
        $(this.collapseFilterList.nativeElement).slideToggle('slow');
    }

    private onFilterChange(e) {
        if(this.filters.config && this.filters.config.dropdownType) {
            this.emitChangeOnCombobox(e);
        } else {
            this.filterChanged.emit(e);
        }
    }

    private emitChangeOnCombobox(e: any) {
        let status = {};
        status[this.filters.key] = e;
        if (e) this.selectAllForm.controls.selectAll.setValue(false);
        this.filterChanged.emit({id: this.filters.key, status: status });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/filter-section/filter-section.component.ts